import { useState } from "react";
import { IdWindow } from "./IdWindow";

/**
 * Generates a unique ID.
 */
export function useId(): string {
  const [id] = useState(() => {
    let nextId = (window as IdWindow).$nextId ?? 0;
    if (nextId === Number.MAX_SAFE_INTEGER) nextId = 0;

    (window as IdWindow).$nextId = nextId + 1;

    return nextId;
  });

  return `id_${id}`;
}
